module.exports = __webpack_public_path__ + "img/mp-solution-bg-2.2e980e94.jpg";